export const bio = {
  aboutMeHeading: "About me",
  backgroundAlt: "Drawing of hands with palms facing up in the background",
  educationHeading: "Education",
  expertiseHeading: "Expertise",
  highlightsHeading: "Highlights",
};
